import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class CouponQueryCriteriaClass extends BaseCriteriaModel {
  //header
  code?: Optional<string> = Optional.empty();
  namespace?: Optional<string> = Optional.empty();
  name?: Optional<string> = Optional.empty();
  coupon_type?: Optional<string> = Optional.empty();
  serial_number?: Optional<number> = Optional.empty();
  guids?: Optional<string> = Optional.empty();    /** @param guids is comma separated E.g: 4BC80017-22CC-4A29-9511-E22C4EB97AD5,4BC80017-22CC-4A29-9511-E22C4EB97AD5*/

  //extension & line conditon
  hdr_guid?: Optional<string> = Optional.empty();
  line_serial_number?: Optional<number> = Optional.empty();

  //extension fields
  param_code?: Optional<string> = Optional.empty();
  param_name?: Optional<string> = Optional.empty();
  param_type?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();
}

export class CouponCriteriaModelQuery {
  query = '';

  constructor(couponCriteriaModel: CouponQueryCriteriaClass) {

    if (!couponCriteriaModel) {
      return;
    }

    this.query += couponCriteriaModel.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += couponCriteriaModel.namespace.filter(x => x !== '').map(x => '&namespace=' + x).orElse('');
    this.query += couponCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += couponCriteriaModel.coupon_type.filter(x => x !== '').map(x => '&coupon_type=' + x).orElse('');
    this.query += couponCriteriaModel.serial_number.filter(x => x !== null).map(x => '&serial_number=' + x).orElse('');
    this.query += couponCriteriaModel.guids.filter(x => x !== '').map(x => '&guids=' + x).orElse('');

    this.query += couponCriteriaModel.hdr_guid.filter(x => x !== '').map(x => '&hdr_guid=' + x).orElse('');
    this.query += couponCriteriaModel.line_serial_number.filter(x => x !== null).map(x => '&line_serial_number=' + x).orElse('');

    this.query += couponCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += couponCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += couponCriteriaModel.param_type.filter(x => x !== '').map(x => '&param_type=' + x).orElse('');
    this.query += couponCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');

    this.query += '&status=' + couponCriteriaModel.status;
    this.query += '&orderBy=' + couponCriteriaModel.orderBy;
    this.query += '&order=' + couponCriteriaModel.order;
    this.query += '&offset=' + couponCriteriaModel.offset + '&limit=' + couponCriteriaModel.limit;
  }
}
